document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ryzon-ticket-form');
  if (!form) return;

  const endpoint = form.dataset.endpoint;
  const submitBtn = document.getElementById('tf-submit');
  const fileInput = document.getElementById('tf-attachments');
  const successEl = document.getElementById('ticket-success');
  const errorBanner = document.getElementById('ticket-error-banner');

  const MAX_FILES = 5;
  const MAX_BYTES = 10 * 1024 * 1024; // 10 MB
  const ALLOWED_MIME = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];

  const REQUIRED = ['email', 'topics', 'subject', 'description'];

  function isGerman() {
    const locale = form.querySelector('[name="locale"]')?.value || 'de';
    return locale.startsWith('de');
  }

  const t = (de, en) => (isGerman() ? de : en);

  function fieldError(name) {
    const input = form.querySelector(`[name="${name}"]`);
    return input?.closest('.ticket-form__field')?.querySelector('.ticket-form__field-error') || null;
  }

  function setError(name, message) {
    const el = fieldError(name);
    if (el) el.textContent = message || '';
  }

  function clearErrors() {
    form.querySelectorAll('.ticket-form__field-error').forEach(el => (el.textContent = ''));
  }

  function validate() {
    clearErrors();
    let valid = true;
    const requiredMsg = t('Dieses Feld ist erforderlich.', 'This field is required.');

    REQUIRED.forEach(name => {
      const input = form.querySelector(`[name="${name}"]`);
      if (input && !input.value.trim()) {
        setError(name, requiredMsg);
        valid = false;
      }
    });

    const email = form.querySelector('[name="email"]');
    if (email && email.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      setError('email', t('Bitte gib eine gültige E-Mail-Adresse ein.', 'Please enter a valid email address.'));
      valid = false;
    }

    const files = fileInput ? Array.from(fileInput.files) : [];
    if (files.length > MAX_FILES) {
      setError('attachments', t(`Maximal ${MAX_FILES} Dateien.`, `Maximum ${MAX_FILES} files.`));
      valid = false;
    }
    for (const file of files) {
      if (file.size > MAX_BYTES) {
        setError('attachments', t('Jede Datei darf höchstens 10 MB groß sein.', 'Each file may be at most 10 MB.'));
        valid = false;
        break;
      }
      if (!ALLOWED_MIME.includes(file.type)) {
        setError('attachments', t('Nur JPG, PNG, WEBP oder PDF erlaubt.', 'Only JPG, PNG, WEBP or PDF allowed.'));
        valid = false;
        break;
      }
    }

    return valid;
  }

  form.addEventListener('submit', async e => {
    e.preventDefault();
    errorBanner.hidden = true;

    if (!validate()) return;

    const formData = new FormData(form);

    submitBtn.setAttribute('aria-busy', 'true');
    submitBtn.disabled = true;

    try {
      // No Content-Type header — the browser sets the multipart boundary.
      const res = await fetch(endpoint, { method: 'POST', body: formData });
      const json = await res.json().catch(() => ({}));

      if (res.ok && json.success) {
        form.hidden = true;
        successEl.hidden = false;
      } else if (res.status === 400 && Array.isArray(json.fields)) {
        json.fields.forEach(name =>
          setError(name, t('Bitte überprüfe dieses Feld.', 'Please check this field.'))
        );
      } else {
        errorBanner.hidden = false;
      }
    } catch {
      errorBanner.hidden = false;
    } finally {
      submitBtn.removeAttribute('aria-busy');
      submitBtn.disabled = false;
    }
  });
});
